import React from 'react';
import { User, ShieldBan, ShieldCheck, BellOff, Bell, Trash2 } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Chat header: title, subtitle (typing / online / connection), optional admin actions.
 * Admin-only: profile link, block, mute (local), delete thread.
 */
export default function ChatHeader({
  title,
  subtitle,
  isConnected,
  showAdminActions = false,
  threadBlocked,
  muted,
  onProfile,
  onBlock,
  onMute,
  onDeleteThread,
  className,
}) {
  return (
    <header
      className={cn(
        'px-4 py-3 border-b border-border bg-card flex items-center justify-between shrink-0',
        className
      )}
    >
      <div className="min-w-0 flex-1">
        <h1 className="font-semibold text-foreground truncate text-base">{title}</h1>
        <p className="text-xs text-muted-foreground truncate mt-0.5">{subtitle}</p>
      </div>

      {showAdminActions && (
        <div className="flex items-center gap-1 shrink-0">
          {onProfile && (
            <button
              type="button"
              data-testid="customer-profile-btn"
              title="View profile"
              onClick={onProfile}
              className="w-9 h-9 rounded-full flex items-center justify-center hover:bg-muted transition text-muted-foreground hover:text-foreground"
            >
              <User className="w-5 h-5" />
            </button>
          )}
          {onBlock && (
            <button
              type="button"
              data-testid="block-chat-btn"
              title={threadBlocked ? 'Unblock chat' : 'Block chat'}
              onClick={onBlock}
              className={cn(
                'w-9 h-9 rounded-full flex items-center justify-center hover:bg-muted transition',
                threadBlocked ? 'text-destructive' : 'text-muted-foreground hover:text-foreground'
              )}
            >
              {threadBlocked ? (
                <ShieldCheck className="w-5 h-5" />
              ) : (
                <ShieldBan className="w-5 h-5" />
              )}
            </button>
          )}
          {onMute != null && (
            <button
              type="button"
              data-testid="mute-chat-btn"
              title={muted ? 'Unmute notifications' : 'Mute notifications'}
              onClick={onMute}
              className={cn(
                'w-9 h-9 rounded-full flex items-center justify-center hover:bg-muted transition',
                muted ? 'text-destructive' : 'text-muted-foreground hover:text-foreground'
              )}
            >
              {muted ? <BellOff className="w-5 h-5" /> : <Bell className="w-5 h-5" />}
            </button>
          )}
          {onDeleteThread && (
            <button
              type="button"
              data-testid="delete-chat-btn"
              title="Delete entire chat"
              onClick={onDeleteThread}
              className="w-9 h-9 rounded-full flex items-center justify-center hover:bg-muted transition text-muted-foreground hover:text-destructive"
            >
              <Trash2 className="w-5 h-5" />
            </button>
          )}
        </div>
      )}
    </header>
  );
}
